import {  teamConstants } from 'Constants/team.constants';
import Request from 'Services/request';
import { alterQueryRequest,  findCurrentPageRequest, queryParser } from 'Helpers/urlform'
import { toast as toastr } from 'react-toastify';
import { getUsers } from 'Helpers/queries';
import { handleApiError } from 'Helpers/index';
import { ClearAutoLogout, AutoLogout } from 'Helpers/AutoLogout';
import {  formatDateTime } from 'Components/Common/TimeStamp';

const requestTeam = team =>({ 
    type: teamConstants.TEAM_REQUEST, 
    team 
})

const successTeam = teamObj =>({
    id: Date.now(),
    type: teamConstants.TEAM_GET_SUCCESS,
    team:teamObj.data,
    totalRecords:teamObj.count,
    currentPage:teamObj.currentPage
})

const successUpdateTeam = teamObj =>({
  type: teamConstants.UPDATE_TEAM_SUCCESS,
  team:teamObj
})

const failureTeam = error =>({
    type: teamConstants.TEAM_FAILURE,
    error
})

const failureAddTeam = error =>({
  type: teamConstants.TEAM_ADD_FORM_FAILURE,
  error
})

const failureEditTeam = error =>({
  type: teamConstants.TEAM_EDIT_FORM_FAILURE,
  error
})

const requestUsersList = usersList =>({
  type:teamConstants.USERS_REQUEST,
  usersList
})

const sucessUsersList = usersListObject => ({
  id: Date.now(),
  type:teamConstants.USERS_SUCCESS,
  usersListObject:usersListObject.data,
  totalRecords:usersListObject.count,
  currentPage:usersListObject.currentPage
})

const failureUsersList = error => ({
  type:teamConstants.USERS_FAILURE,
  error
})

const requestGetEditFormObject = () => ({
  type: teamConstants.EDIT_FORM_GET_REQUEST
})

const successGetEditFormObject = (editFormObj) => ({
  type: teamConstants.EDIT_FORM_GET_SUCCESS,
  editObj: editFormObj,
})

const failureGetEditFormObject = (error) => ({
  type: teamConstants.EDIT_FORM_GET_FAILURE,
  error
})

function fetchTeam(SearchArray) {
  let url = '/team';
  if(SearchArray && SearchArray.length > 0 ) {
    url = queryParser(url,SearchArray);
  }  
  const currentPage = findCurrentPageRequest(SearchArray);
  return async (dispatch) => {
    dispatch(requestTeam({}));
    await Request.get(url, {})
      .then(( response ) => {
        const { data,count } = response;
        dispatch(successTeam({ data, count, currentPage }));
      })
      .catch((error) => {
        if(error) {
          handleApiError(error);
          dispatch(failureTeam(error.toString()));
        }
      });
  };
}

let aborter = null;
function fetchUsers(SearchArray, bodyObj){
  ClearAutoLogout();
  let url = '/team/teamMemberSearch'
  if(SearchArray && SearchArray.length > 0 ) {
    url = queryParser(url,SearchArray);
  }  
  const currentPage = findCurrentPageRequest(SearchArray);
  if(aborter) aborter.abort();
  aborter = new AbortController();
  const signal = aborter.signal;
  return async (dispatch) => {
      dispatch(requestUsersList({}));
        Request.create(url,
        { ...bodyObj })
        .then( res => {
          AutoLogout();
          aborter = null;
          const { data = [], count } = res;
          dispatch(sucessUsersList({ data, count, currentPage }));
        })
        .catch((error) => {
          AutoLogout();
          if(error) {
            handleApiError(error);
            dispatch(failureUsersList(error.toString()));
          }
        });
    };
}

function addTeam(addTeamObj,SearchArray) {
  return (dispatch) => {
    dispatch(requestTeam({}));
    Request.create(`/team`,
      { ...addTeamObj })
      .then((response) => {
        const { message } = response;        
        dispatch(fetchTeam(SearchArray))
        dispatch(exportTeam(SearchArray))
        toastr.dismiss();
        toastr.success(message);
      })
      .catch((error) => {
        if(error) {
          handleApiError(error);
          dispatch(failureAddTeam(error.toString()));
        }
      });
  };
}

function updateTeam(teamObj,SearchArray) {
  const { id, ...rest } = teamObj
  return (dispatch) => {
    dispatch(requestUsersList({}));
    Request.update(`/team/${ id }`,
      { ...rest })
      .then((response) => {
        const { message } = response;        
        dispatch(successUpdateTeam(teamObj));
        dispatch(fetchTeam(SearchArray))
        dispatch(exportTeam(SearchArray))
        toastr.dismiss();
        toastr.success(message);
      })
      .catch((error) => {
        if(error) {
          handleApiError(error);
          dispatch(failureEditTeam(error.toString()));
        }
      });
  };
}

function deleteTeam(id, SearchArray, remainningRecords,currentPage){
  const updateSearchArray = alterQueryRequest(SearchArray, remainningRecords,currentPage);
    return (dispatch) => {
        dispatch(requestTeam({}));
        Request.remove(`/team?id=${ id }`,
        {  })
        .then((response) => {
          const { message } = response;
          dispatch(fetchTeam(updateSearchArray));
          dispatch(exportTeam(updateSearchArray))
          toastr.dismiss();
          toastr.success(message);
        })
        .catch((error) => {
          if(error) {
            handleApiError(error);
            dispatch(failureTeam(error.toString()));
          }
        });
    }
}

function fetchEditObj(id) {
  return (dispatch) => {
    dispatch(requestGetEditFormObject());
    Request.get(`/team/${ id }`)
      .then((response) => {
        const { data } = response;
        dispatch(successGetEditFormObject(data));
      })
      .catch((error) => {
        if(error) {
          handleApiError(error);
          dispatch(failureGetEditFormObject(error.toString()));
        }
      });
  };
}

const requestTeamExportData = exportData => ({
  type: teamConstants.EXPORT_TEAM_REQUEST, 
  exportData
})

const successTeamExportData = exportDataObj => ({
  type: teamConstants.EXPORT_TEAM_SUCCESS,
  exportData: exportDataObj.data,
  totalRecords: exportDataObj.count
})

const failureTeamExportData = error => ({
  type: teamConstants.EXPORT_TEAM_FAILURE,
  error
})

function exportTeam(SearchArray) {
  let url = '/team';
  if (SearchArray && SearchArray.length > 0) {
    url = queryParser(url, SearchArray);
  }
  const exportUrl = SearchArray && SearchArray.length > 0 ? `&exportType=true` : `?exportType=true`;
  url = `${ url }${ exportUrl }`;
  return async (dispatch) => {
    dispatch(requestTeamExportData({}));
    await Request.get(url, {})
      .then(( response ) => {
        const { data = [], count } = response;
        data.forEach(function(res){ 
          const createdAt = formatDateTime(res.createdAt);
          res[ 'Team Name' ] = res.teamName;
          res[ 'About Team' ] = res.aboutTeam;
          res[ 'Created Date' ] = createdAt && createdAt;
          // res[ 'Users Count' ] = res.teamMembersCount;
          delete res.id; delete res.teamMembers; delete res.image; 
          delete res.teamName; delete res.aboutTeam; delete res.createdAt; 
          delete res.teamMembersCount; delete res.isActive;
          //res.isActive = res.isActive === 1 ? 'Enable' : 'Disable';
        });
        dispatch(successTeamExportData({ data, count }));
      })
      .catch((error) => {
        if(error) {
          handleApiError(error);
          dispatch(failureTeamExportData(error.toString()));
        }
      });
  };    
}

export const TeamAction ={
    fetchTeam,
    addTeam,
    updateTeam,
    deleteTeam,
    fetchUsers,
    fetchEditObj,
    exportTeam,
}